import { Button, Dialog, DialogContent, DialogContentText, DialogActions, IconButton } from '@material-ui/core';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import * as React from 'react';
import { PureComponent } from 'react';
import { WithStyles } from 'decorators/withStyles';
import CloseIcon from 'mdi-react/CloseIcon';
import Typography from '@material-ui/core/Typography/Typography';

interface IProps {
  title: string;
  text: string;
  opened: boolean;
  handleContinue: () => void;
  handleSaveSketch: () => void;
  handleClose: () => void;
  classes?: any;
}

interface IState {
  open: boolean;
}

@WithStyles(theme => ({
  continueButton: {
    color: '#FFF',
    backgroundColor: theme.variables.colors['primaryColor'],
    textTransform: 'capitalize',
    cursor: 'pointer',
    padding: '10px 16px',
    '&:hover': {
      backgroundColor: theme.variables.colors['buttonBackgroundHover']
    }
  },
  sketchButton: {
    textTransform: 'capitalize',
    backgroundColor: '#FFF',
    color: theme.variables.colors['primaryColor'],
    cursor: 'pointer',
    padding: '10px 16px',
    '&:hover': {
      backgroundColor: '#f3f3f5'
    }
  },
  text: {
    color: '#37474F',
    fontWeight: 500,
    fontSize: '16px',
    lineHeight: '150%'
  },
  conteinerTitle: {
    display: 'flex',
    flexDirection: 'row',
    '& button': {
      padding: 0
    }
  },
  title: {
    flexGrow: 1,
    color: `${theme.variables.colors['primaryColor']} !important`,
    textAlign: 'left'
  }
}))
export default class DialogSave extends PureComponent<IProps, IState> {
  render() {
    const { classes } = this.props;
    const { handleContinue, handleSaveSketch, handleClose, title, text, opened } = this.props;

    return (
      <Dialog
        open={opened}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        onClose={handleClose}
      >
        <MuiDialogTitle disableTypography className={classes.conteinerTitle}>
          <Typography id="alert-dialog-title" variant="h6" className={classes.title}>
            {title}
          </Typography>
          <IconButton aria-label="close" className={classes.closeButton} onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </MuiDialogTitle>
        <DialogContent>
          <DialogContentText className={classes.text} id="alert-dialog-description">
            {text}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleSaveSketch} color="primary" autoFocus className={classes.sketchButton}>
            Salvar
          </Button>
          <Button onClick={handleContinue} color="primary" className={classes.continueButton}>
            Continuar
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}
